import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { CafDocAuthenticatorContainer } from "./caf-doc-authenticator.container";

const DIRECTIVES = [CafDocAuthenticatorContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule, DialogLayoutModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CafDocAuthenticatorModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, CafDocAuthenticatorContainer);
	}
}
